import { render, staticRenderFns } from "./DomoEmbedList.vue?vue&type=template&id=7230c508&scoped=true"
import script from "./DomoEmbedList.vue?vue&type=script&lang=js"
export * from "./DomoEmbedList.vue?vue&type=script&lang=js"
import style0 from "./DomoEmbedList.vue?vue&type=style&index=0&id=7230c508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7230c508",
  null
  
)

export default component.exports